import * as Icons from "lucide-react";
import { WHY_REASONS } from "@/lib/site";

export const WhySection = () => {
  return (
    <section className="bg-white border-y border-[var(--border)]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-20 items-start">
          <div className="md:col-span-5 md:sticky md:top-[110px]">
            <div className="eyebrow">Why Weston Commercial</div>
            <h2 className="section-title text-[44px] md:text-[64px] mt-4 leading-[1.02]">
              A workplace that says <em className="italic text-[var(--primary)]">we&apos;re established</em> — before you do.
            </h2>
            <p className="mt-6 text-[15px] text-[var(--text-muted)] max-w-md leading-relaxed">
              We built Weston Commercial Center for the kind of business
              you&apos;ve worked hard to become. Professional, refined, and made
              to grow with you.
            </p>
          </div>
          <div className="md:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[var(--border)] hairline">
              {WHY_REASONS.map((r) => {
                const Icon = Icons[r.icon] || Icons.Star;
                return (
                  <div key={r.title} className="bg-white p-8">
                    <Icon size={22} strokeWidth={1.3} className="text-[var(--primary)]" />
                    <h3 className="font-serif text-[22px] mt-4 leading-tight">{r.title}</h3>
                    <p className="text-[13.5px] text-[var(--text-muted)] mt-2 leading-relaxed">
                      {r.body}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhySection;
